<template>
  <div class="layouts">
    <router-view></router-view>
  </div>
</template>

<script>
import { localeValueToKeyMap } from '@/assets/js/multilingual-tools';
export default {
  created() {
    // this.$i18n.locale = localeValueToKeyMap[navigator.language];
    // console.log(
    //   'localeValueToKeyMap[navigator.language]: ',
    //   localeValueToKeyMap[navigator.language]
    // );
  }
};
</script>
